<template>
  <div class="salesmanfenliustreamPage">   
      <mu-appbar title="分流记录">
        <div slot="right" class="title-text" @click="open('top')" >
          <p>筛选 </p>    
          <mu-popup position="top" popupClass="salesmanfenliustreamPage-popup" :open="topPopup" @close="close('top')">
            <mu-content-block>
              <div class="popuptitle delivery-type-order">
                <div class="button-list">                  
                  <mu-flat-button @click="searchTypeChange(1)" :label="'获得套餐 '+fenliuInfo.TotalCount" class="demo-flat-button"/>
                  <mu-flat-button @click="searchTypeChange(2)" :label="'分流套餐 '+fenliuInfo.UseCount" class="demo-flat-button"/>
                </div>
              </div>              
            </mu-content-block>
          </mu-popup>      
        </div>
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
    </mu-appbar>   
    
    <mu-list >
        <mu-list-item class=" proList"  v-for="item in fenliuData.List" :key="item.Id">
            <div class="mu-item-title">
                 <div class="list-content">
                    <div class="dd1">
                       <p>{{item.ToUser}} </p><p class="date">{{item.ToUserMobile}}</p>
                    </div>           
                    <div class="dd2"><span class="type">{{item.ModifyCount >0? '+'+item.ModifyCount:item.ModifyCount}}</span>  分流套餐<p class="font-color">{{item.CreateTimeName}}</p></div>
                </div>             
            </div>
        </mu-list-item>
    </mu-list>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>
<script>
export default {
  data () {
    return {
      titleIcon : 'fa fa-angle-down',
      topPopup: false,
     searchInfo:{
       type :1,
       pageIndex:1,
       pageSize:1000
     },
     fenliuInfo:{
       TotalCount:0,
       UseCount:0
     },
     fenliuData:{},
    }
  },
  mounted(){
    this.getInfo()
    this.getList()
  },
  methods: {
    GoHistory(){
      this.$router.goBack()
    },
    open (position) {
      this[position + 'Popup'] = true
      this.titleIcon = "fa fa-angle-up";
    },
    close (position) {
      this[position + 'Popup'] = false
      this.titleIcon = "fa fa-angle-down";
    },
    searchTypeChange (val) {
        this.searchInfo.type = val
        this.getList()    
        this.close('top')    
    },    

    getInfo(){            
        var ths = this;  
        
        ths.$post(
            "/Salesman/SalesmanServer/GetFenLiuTotalByMinnerBm",{SalesmanType:1}
        ).then(function(res) {
            if(!res.IsSuccess){                
                ths.$refs.XRPageTip.ShowEmpty(res.Msg)
            }else{
                ths.fenliuInfo = res.Data
            }
        });
    },        
    getList(){            
        var ths = this;  
        
        ths.$post(
            "/Salesman/SalesmanServer/GetFenLiuPackageStreamByMinnerBm", this.searchInfo
        ).then(function(res) {
            if(!res.IsSuccess){
                ths.$refs.XRPageTip.ShowEmpty(res.Msg)
            }else{
                ths.fenliuData = res.Data
                ths.$refs.XRPageTip.initTip()
            }
        });
    }
  }
}
</script>
<style>

         body .salesmanfenliustreamPage{
            background: #fff;
            bottom:unset;
            padding-bottom: 56px;
        }
        .salesmanfenliustreamPage .dd1
        {
            float:left;
            width:60%;
            text-align:left;
            font-size:14px;
        }
        .salesmanfenliustreamPage .mu-appbar{
        position: fixed;
        top: 0;
        z-index: 20180101;
    }
    .salesmanfenliustreamPage .mu-list{
        top: 56px;
    }
    .salesmanfenliustreamPage .mu-appbar-title {
        font-size: 16px;
    }
    .salesmanfenliustreamPage .right .title-text{
        font-size: 16px;
    }
    .salesmanfenliustreamPage-popup {
        width: 100%;
        top:46px;
        height: 160px;
        z-index: 1;
        padding: 20px 0;
    }
    .salesmanfenliustreamPage-popup .popuptitle .title{
        overflow: hidden;
    }
    .salesmanfenliustreamPage-popup .popuptitle .title .text{
        float: left; 
        width:20%;
        text-align: center;
        line-height: 24px;
        color:#ccc;
    }
    .salesmanfenliustreamPage-popup .popuptitle .title .line{
        float: left; 
        height: 1px;
        background:#eee;
        width: 80%;
        border: none;
        margin-top: 10px;
    }
      .salesmanfenliustreamPage .dd1 .date { color: #999; font-size:12px;}
        .dd2
        {
            float:right;
            width:40%;
            text-align:center;
            padding-left:2%;
            font-size:12px;
        }
     .salesmanfenliustreamPage .dd2 .type { color: red; font-size:14px; }
     .salesmanfenliustreamPage .dd3
        {
            float:left;
            width:20%;
            text-align:center;
        }
      .salesmanfenliustreamPage .dd2 .font-color { color: #999; font-size:12px;}
              .dd3 .btn
        {
          background-color: #e2000e;
          color: #fff;
          display: block;
          width: 60px;
          height: 18px;
          font-size: 12px;
          margin-top: 9px;
          margin-left: 10%;
          float: right;
        }
       .salesmanfenliustreamPage .mu-raised-button{
          min-width: 0px;
        }
       .salesmanfenliustreamPage .mu-item{
           border-bottom: 1px solid #f9f9f9;
        }
        .salesmanfenliustreamPage .proList:last-child .mu-item{
           border: 0;
        }
</style>



// WEBPACK FOOTER //
// src/pages/salesman/fenliuStream.vue